;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .directive('inputCarrossel', inputCarrossel)

  /* @ngInject */
  function inputCarrossel () {
    return {
      restrict: 'E',
      scope: {
        label: '@',
        description: '@',
        model: '=',
        assets: '<',
        readOnly: '<',
        variations: '<', // space-delimited
        mandatory: '<',
        onChange: '&',
        value: '<',
        fieldId: '<',
        allowMultiselect: '<'
      },
      templateUrl: '/core/directives/input-carrossel/input-carrossel-directive.html?$$REVISION$$',
      controller: 'InputCarrosselController'
    }
  }
})()
